import { GoogleAuthProvider, FacebookAuthProvider, GithubAuthProvider } from "firebase/auth";

const googleProvider = new GoogleAuthProvider()
const facebookProvider = new FacebookAuthProvider()
const githubProvider = new GithubAuthProvider()


export {googleProvider, facebookProvider, githubProvider}